import React from "react";
import { Table, Badge, Button } from "reactstrap";

/**
 * Komponen Tabel untuk menampilkan daftar permintaan
 */
export default function PermintaanTable({
  data = [],
  loading = false,
  emptyMessage = "Tidak ada data permintaan",
}) {
  if (loading) {
    return <p>Memuat data...</p>;
  }

  const getStatusBadge = (status) => {
    const statusMap = {
      pending: { color: "warning", text: "Pending" },
      diproses: { color: "info", text: "Diproses" },
      ditolak: { color: "danger", text: "Ditolak" },
      selesai: { color: "success", text: "Selesai" },
    };
    const statusInfo = statusMap[status] || {
      color: "secondary",
      text: status,
    };
    return <Badge color={statusInfo.color}>{statusInfo.text}</Badge>;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <Table responsive hover borderless className="mb-0 align-middle">
      <thead>
        <tr>
          <th>No Faktur</th>
          <th>Tanggal</th>
          <th>Status</th>
          <th>Jumlah Item</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {!data || data.length === 0 ? (
          <tr>
            <td colSpan="5" className="text-center text-muted">
              {emptyMessage}
            </td>
          </tr>
        ) : (
          data.map((item, index) => (
            <tr key={item.id || index}>
              <td>{item.noFaktur}</td>
              <td>{formatDate(item.tanggal)}</td>
              <td>{getStatusBadge(item.status)}</td>
              <td>{item.jumlahItem ?? item.total_jumlah ?? item.jumlahItem}</td>
              <td>
                <Button color="primary" size="sm">
                  Detail
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
}
